export const TypeChart: {[k: string]: ModdedTypeData | null} = {
	stellar: {
		inherit: true,
		isNonstandard: 'Future',
	},
};
